
import { demoCopy } from '~/content/dating-demo'

export default {
  auth: false,
  layout: 'marketing',
  computed: {
    locale () { return this.$i18n.locale === 'en' ? 'en' : 'pl' },
    copy () { return demoCopy[this.locale] },
    joinPath () { return this.localePath(this.$auth.user ? '/users' : '/register') }
  },
  methods: {
    focusDemo () {
      this.$nextTick(() => {
        const heading = document.getElementById('demo-heading')
        if (heading) heading.focus({ preventScroll: true })
      })
    }
  },
  head () {
    const url = 'https://jaty.pl' + this.localePath('/randki-bez-rejestracji')
    const schema = { '@context': 'https://schema.org', '@graph': [
      { '@type': 'WebPage', '@id': url, url, name: this.copy.title, description: this.copy.description, inLanguage: this.locale },
      { '@type': 'BreadcrumbList', '@id': url + '#breadcrumb', itemListElement: [
        { '@type': 'ListItem', position: 1, name: this.locale === 'en' ? 'JaTy - home' : 'JaTy - strona główna', item: 'https://jaty.pl' + this.localePath('/') },
        { '@type': 'ListItem', position: 2, name: this.copy.label, item: url }
      ] }
    ] }
    return {
      title: this.copy.title, titleTemplate: null,
      meta: [
        { hid: 'description', name: 'description', content: this.copy.description },
        { hid: 'og:title', property: 'og:title', content: this.copy.title },
        { hid: 'og:description', property: 'og:description', content: this.copy.description },
        { hid: 'og:url', property: 'og:url', content: url },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        { hid: 'og:image', property: 'og:image', content: 'https://jaty.pl/images/randki-demo/w05.webp' },
        { hid: 'og:image:alt', property: 'og:image:alt', content: this.copy.previewAlt }
      ],
      script: [{ hid: 'dating-demo-schema', type: 'application/ld+json', json: schema }]
    }
  }
}
